/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstructionStepResponse
 */
export interface InstructionStepResponse {
    /**
     * 
     * @type {number}
     * @memberof InstructionStepResponse
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof InstructionStepResponse
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof InstructionStepResponse
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the InstructionStepResponse interface.
 */
export function instanceOfInstructionStepResponse(value: object): value is InstructionStepResponse {
    return true;
}

export function InstructionStepResponseFromJSON(json: any): InstructionStepResponse {
    return InstructionStepResponseFromJSONTyped(json, false);
}

export function InstructionStepResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionStepResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'order': json['order'] == null ? undefined : json['order'],
        'text': json['text'] == null ? undefined : json['text'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function InstructionStepResponseToJSON(json: any): InstructionStepResponse {
    return InstructionStepResponseToJSONTyped(json, false);
}

export function InstructionStepResponseToJSONTyped(value?: InstructionStepResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order': value['order'],
        'text': value['text'],
        'imageUrl': value['imageUrl'],
    };
}

